import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "@/components/Header";
import FundList from "@/pages/FundList";
import FundDetail from "@/pages/FundDetail";
import Compare from "@/pages/Compare";
import AmcScorecard from "@/pages/AmcScorecard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<FundList />} />
          <Route path="/fund/:code" element={<FundDetail />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/amcs" element={<AmcScorecard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
